// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3y-0";
export var eligibilityCardNotEligible = "_3y-1";